module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper border-bottom white-bg page-heading"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 col-sm-12 col-lg-2"
  }, [_c('div', {
    staticClass: "text-right m-t-lg"
  }, [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$user.isEnabled),
      expression: "$user.isEnabled"
    }],
    staticClass: "material-plus",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "left",
      "title": "",
      "data-original-title": "Create New Location",
      "to": {
        name: 'locations.create'
      }
    }
  }, [_vm._v("+")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-10 col-lg-10"
  }, [_c('h1', [_c('i', {
    staticClass: "far fa-map-signs m-r-sm"
  }), _vm._v(" Manage Locations")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-59e05bba"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/locations/IndexHeading.vue
// module id = 1010
// module chunks = 0